// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fe3e2dca-2910-43f9-8446-36a33c60808e',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'ef476614-0a14-480c-ba73-30f5337df0bd',
      type: 'Sprite',
      name: 'key_2',
      className: '',
      x: 140,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Key',
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: '4e0550d9-58d1-4350-98ac-e823432b33ad',
      type: 'Container',
      name: 'particleSpawnPoint',
      className: '',
      x: 140,
      y: -13,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: 'dcfb2602-be56-4a6c-bd96-9ed9d6529795',
      type: 'Sprite',
      name: 'keyGlow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Key',
      parent: 'ef476614-0a14-480c-ba73-30f5337df0bd'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '156776da-7bb2-4a9c-b0b2-58ef87b89783',
      name: 'Adding_New_Key_1',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '88aec719-f8b2-4367-b807-f5f3777cbfda',
          type: 'Setter',
          name: 'SFX_Gameplay_Match_3',
          track: 5,
          target: {},
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '395abf18-e2d6-4032-afdb-82fb7fb98e87',
          type: 'Setter',
          name: 'key2Position',
          track: 3,
          target: {
            y: -13,
            x: 140
          },
          startAt: 0,
          sourceName: 'key_2',
          disabled: false
        },
        {
          id: 'c032a417-efbe-4b72-9758-72dcd1e18c09',
          type: 'Setter',
          name: 'partcilePosition',
          track: 8,
          target: {
            scale: {},
            x: 140,
            y: -13
          },
          startAt: 0,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '89e0bb91-7906-4111-a83a-ac10b14f1775',
          type: 'Setter',
          name: 'FXPART_Season_Pass_Key_Particles',
          track: 6,
          target: {},
          startAt: 0,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '6d8cfebe-3bbe-4c4b-bbec-aca5b2c2d994',
          type: 'Tween',
          name: 'key2Alpha_1',
          duration: 250,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6b299914-f32e-459b-aeb4-e0b25a7b9c83',
          type: 'Tween',
          name: 'key2Scale',
          duration: 125,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '87f429d1-e56f-4a77-851e-baea97f25bca',
          type: 'Tween',
          name: 'key2Position_1',
          duration: 600,
          track: 4,
          target: {
            y: -17
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '30b09757-5e1b-4872-a425-da15491d42ad',
          type: 'Tween',
          name: 'New_tween',
          duration: 250,
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'keyGlow',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'c62c84f0-6c4c-4137-ba6d-aa1324c29a4c',
          type: 'Tween',
          name: 'key2Scale_1_1',
          duration: 65,
          track: 2,
          target: {
            scale: {
              x: 0.9,
              y: 0.9
            }
          },
          startAt: 125,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '949a78e2-1169-407c-b825-241aeb9d42c3',
          type: 'Tween',
          name: 'key2Scale_1',
          duration: 60,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 190,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ff0d5852-1d73-4b29-808f-da89d833c7da',
          type: 'Tween',
          name: 'keyGlowAlpha_1',
          duration: 300,
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 250,
          sourceName: 'keyGlow',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'da9cf670-0deb-4f75-8124-6d21d57f6523',
          type: 'Tween',
          name: 'key2Scale_1_2',
          duration: 50,
          track: 2,
          target: {
            scale: {
              x: 1.06,
              y: 0.93
            }
          },
          startAt: 550,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2516b4f8-69f4-4223-89dd-4ea0d8ae94b8',
          type: 'Tween',
          name: 'key2Position_1_1',
          duration: 100,
          track: 4,
          target: {
            x: 111,
            y: -62
          },
          startAt: 600,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '920d8e36-023a-4581-b392-2d2995882c3e',
          type: 'Tween',
          name: 'key2Scale_1_3',
          duration: 100,
          track: 2,
          target: {
            scale: {
              x: 0.93,
              y: 1.06
            }
          },
          startAt: 600,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '14d6ae04-4b45-497a-a331-a6d8e8516230',
          type: 'Tween',
          name: 'key2Position_1_1_copy',
          duration: 100,
          track: 4,
          target: {
            x: 74,
            y: -76
          },
          startAt: 700,
          sourceName: 'key_2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'ce6ac952-e984-4562-abb9-53c37c5878a1',
          type: 'Tween',
          name: 'key2Scale_1_4',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 0.3,
              y: 0.3
            }
          },
          startAt: 700,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '85f17593-4faa-4ef2-a081-31eaf6058430',
          type: 'Tween',
          name: 'key2Position_1_1_copy_copy',
          duration: 100,
          track: 4,
          target: {
            x: 27,
            y: -53
          },
          startAt: 800,
          sourceName: 'key_2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '2450b1fb-681c-497c-a89a-a2c1d6003482',
          type: 'Tween',
          name: 'key2Position_1_1_copy_copy_copy',
          duration: 100,
          track: 4,
          target: {
            x: 0,
            y: 0
          },
          startAt: 900,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'ed8037e0-71be-4943-a67f-c36649e66c96',
      name: 'Adding_New_Key_2',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '88aec719-f8b2-4367-b807-f5f3777cbfda',
          type: 'Setter',
          name: 'SFX_Gameplay_Match_3',
          track: 5,
          target: {},
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '395abf18-e2d6-4032-afdb-82fb7fb98e87',
          type: 'Setter',
          name: 'key2Position',
          track: 3,
          target: {
            y: -30,
            x: 120
          },
          startAt: 0,
          sourceName: 'key_2',
          disabled: false
        },
        {
          id: '093a4408-b78e-4358-98ac-2a16da9ca024',
          type: 'Setter',
          name: 'FXPART_Season_Pass_Key_Particles',
          track: 6,
          target: {},
          startAt: 0,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '1c7debc0-dadd-4bab-8ee2-93c6ac0a4aa4',
          type: 'Setter',
          name: 'particlePosition',
          track: 8,
          target: {
            x: 120,
            y: -30
          },
          startAt: 0,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '6d8cfebe-3bbe-4c4b-bbec-aca5b2c2d994',
          type: 'Tween',
          name: 'key2Alpha_1',
          duration: 250,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6b299914-f32e-459b-aeb4-e0b25a7b9c83',
          type: 'Tween',
          name: 'key2Scale',
          duration: 125,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '87f429d1-e56f-4a77-851e-baea97f25bca',
          type: 'Tween',
          name: 'key2Position_1',
          duration: 600,
          track: 4,
          target: {
            y: -34
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8aae3d8d-f856-4169-a9cc-b0b6bb7441ca',
          type: 'Tween',
          name: 'keyGlowAlpha',
          duration: 250,
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'keyGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c62c84f0-6c4c-4137-ba6d-aa1324c29a4c',
          type: 'Tween',
          name: 'key2Scale_1_1',
          duration: 65,
          track: 2,
          target: {
            scale: {
              x: 0.9,
              y: 0.9
            }
          },
          startAt: 125,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '949a78e2-1169-407c-b825-241aeb9d42c3',
          type: 'Tween',
          name: 'key2Scale_1',
          duration: 60,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 190,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '26ff59b2-02f5-4668-9f7a-7557412bb513',
          type: 'Tween',
          name: 'keyGlowAlpha_copy',
          duration: 300,
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 250,
          sourceName: 'keyGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'da9cf670-0deb-4f75-8124-6d21d57f6523',
          type: 'Tween',
          name: 'key2Scale_1_2',
          duration: 50,
          track: 2,
          target: {
            scale: {
              x: 1.06,
              y: 0.93
            }
          },
          startAt: 550,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2516b4f8-69f4-4223-89dd-4ea0d8ae94b8',
          type: 'Tween',
          name: 'key2Position_1_1',
          duration: 100,
          track: 4,
          target: {
            x: 111,
            y: -62
          },
          startAt: 600,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '920d8e36-023a-4581-b392-2d2995882c3e',
          type: 'Tween',
          name: 'key2Scale_1_3',
          duration: 100,
          track: 2,
          target: {
            scale: {
              x: 0.93,
              y: 1.06
            }
          },
          startAt: 600,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '14d6ae04-4b45-497a-a331-a6d8e8516230',
          type: 'Tween',
          name: 'key2Position_1_1_copy',
          duration: 100,
          track: 4,
          target: {
            x: 74,
            y: -76
          },
          startAt: 700,
          sourceName: 'key_2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'ce6ac952-e984-4562-abb9-53c37c5878a1',
          type: 'Tween',
          name: 'key2Scale_1_4',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 0.3,
              y: 0.3
            }
          },
          startAt: 700,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '85f17593-4faa-4ef2-a081-31eaf6058430',
          type: 'Tween',
          name: 'key2Position_1_1_copy_copy',
          duration: 100,
          track: 4,
          target: {
            x: 27,
            y: -53
          },
          startAt: 800,
          sourceName: 'key_2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '2450b1fb-681c-497c-a89a-a2c1d6003482',
          type: 'Tween',
          name: 'key2Position_1_1_copy_copy_copy',
          duration: 100,
          track: 4,
          target: {
            x: 0,
            y: 0
          },
          startAt: 900,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'ae34b021-68e4-4864-96e5-bb121d1a78d1',
      name: 'Adding_New_Key_3',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '88aec719-f8b2-4367-b807-f5f3777cbfda',
          type: 'Setter',
          name: 'SFX_Gameplay_Match_3',
          track: 5,
          target: {},
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '395abf18-e2d6-4032-afdb-82fb7fb98e87',
          type: 'Setter',
          name: 'key2Position',
          track: 3,
          target: {
            y: 4,
            x: 160
          },
          startAt: 0,
          sourceName: 'key_2',
          disabled: false
        },
        {
          id: '91b40245-44e2-483e-b921-0d509c6be9b2',
          type: 'Setter',
          name: 'particlePosition',
          track: 8,
          target: {
            x: 160,
            y: 4
          },
          startAt: 0,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '2ca0210d-5778-42dc-9a3e-ae1b8b0542a4',
          type: 'Setter',
          name: 'FXPART_Season_Pass_Key_Particles',
          track: 6,
          target: {},
          startAt: 0,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '6d8cfebe-3bbe-4c4b-bbec-aca5b2c2d994',
          type: 'Tween',
          name: 'key2Alpha_1',
          duration: 250,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6b299914-f32e-459b-aeb4-e0b25a7b9c83',
          type: 'Tween',
          name: 'key2Scale',
          duration: 125,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '87f429d1-e56f-4a77-851e-baea97f25bca',
          type: 'Tween',
          name: 'key2Position_1',
          duration: 600,
          track: 4,
          target: {
            y: 0
          },
          startAt: 0,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8ab5ad29-40fa-4a69-b6d6-c31b17744c47',
          type: 'Tween',
          name: 'keyGlowAlpha_2',
          duration: 250,
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'keyGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c62c84f0-6c4c-4137-ba6d-aa1324c29a4c',
          type: 'Tween',
          name: 'key2Scale_1_1',
          duration: 65,
          track: 2,
          target: {
            scale: {
              x: 0.9,
              y: 0.9
            }
          },
          startAt: 125,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '949a78e2-1169-407c-b825-241aeb9d42c3',
          type: 'Tween',
          name: 'key2Scale_1',
          duration: 60,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 190,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e8d658a2-7540-4b7b-9ff1-615751ccf76e',
          type: 'Tween',
          name: 'keyGlowAlpha_2_copy',
          duration: 300,
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 250,
          sourceName: 'keyGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'da9cf670-0deb-4f75-8124-6d21d57f6523',
          type: 'Tween',
          name: 'key2Scale_1_2',
          duration: 50,
          track: 2,
          target: {
            scale: {
              x: 1.06,
              y: 0.93
            }
          },
          startAt: 550,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2516b4f8-69f4-4223-89dd-4ea0d8ae94b8',
          type: 'Tween',
          name: 'key2Position_1_1',
          duration: 100,
          track: 4,
          target: {
            x: 111,
            y: -62
          },
          startAt: 600,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '920d8e36-023a-4581-b392-2d2995882c3e',
          type: 'Tween',
          name: 'key2Scale_1_3',
          duration: 100,
          track: 2,
          target: {
            scale: {
              x: 0.93,
              y: 1.06
            }
          },
          startAt: 600,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '14d6ae04-4b45-497a-a331-a6d8e8516230',
          type: 'Tween',
          name: 'key2Position_1_1_copy',
          duration: 100,
          track: 4,
          target: {
            x: 74,
            y: -76
          },
          startAt: 700,
          sourceName: 'key_2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'ce6ac952-e984-4562-abb9-53c37c5878a1',
          type: 'Tween',
          name: 'key2Scale_1_4',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 0.3,
              y: 0.3
            }
          },
          startAt: 700,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '85f17593-4faa-4ef2-a081-31eaf6058430',
          type: 'Tween',
          name: 'key2Position_1_1_copy_copy',
          duration: 100,
          track: 4,
          target: {
            x: 27,
            y: -53
          },
          startAt: 800,
          sourceName: 'key_2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '2450b1fb-681c-497c-a89a-a2c1d6003482',
          type: 'Tween',
          name: 'key2Position_1_1_copy_copy_copy',
          duration: 100,
          track: 4,
          target: {
            x: 0,
            y: 0
          },
          startAt: 900,
          sourceName: 'key_2',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassMenuAddingKeyAnimation {
  static raw = raw;
  root!: Container;
  key_2!: Sprite;
  particleSpawnPoint!: Container;
  keyGlow!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Adding_New_Key_1 {
  Layout: {
    root: object;
    key_2: object;
    particleSpawnPoint: object;
    keyGlow: object;
  };

  BlockTypeByName: {
    SFX_Gameplay_Match_3: object;
    key2Position: object;
    partcilePosition: object;
    FXPART_Season_Pass_Key_Particles: object;
    key2Alpha_1: object;
    key2Scale: object;
    key2Position_1: object;
    New_tween: object;
    key2Scale_1_1: object;
    key2Scale_1: object;
    keyGlowAlpha_1: object;
    key2Scale_1_2: object;
    key2Position_1_1: object;
    key2Scale_1_3: object;
    key2Position_1_1_copy: object;
    key2Scale_1_4: object;
    key2Position_1_1_copy_copy: object;
    key2Position_1_1_copy_copy_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Adding_New_Key_2 {
  Layout: {
    root: object;
    key_2: object;
    particleSpawnPoint: object;
    keyGlow: object;
  };

  BlockTypeByName: {
    SFX_Gameplay_Match_3: object;
    key2Position: object;
    FXPART_Season_Pass_Key_Particles: object;
    particlePosition: object;
    key2Alpha_1: object;
    key2Scale: object;
    key2Position_1: object;
    keyGlowAlpha: object;
    key2Scale_1_1: object;
    key2Scale_1: object;
    keyGlowAlpha_copy: object;
    key2Scale_1_2: object;
    key2Position_1_1: object;
    key2Scale_1_3: object;
    key2Position_1_1_copy: object;
    key2Scale_1_4: object;
    key2Position_1_1_copy_copy: object;
    key2Position_1_1_copy_copy_copy: object;
  };

  flowData = raw.animations[1];
}

export abstract class Adding_New_Key_3 {
  Layout: {
    root: object;
    key_2: object;
    particleSpawnPoint: object;
    keyGlow: object;
  };

  BlockTypeByName: {
    SFX_Gameplay_Match_3: object;
    key2Position: object;
    particlePosition: object;
    FXPART_Season_Pass_Key_Particles: object;
    key2Alpha_1: object;
    key2Scale: object;
    key2Position_1: object;
    keyGlowAlpha_2: object;
    key2Scale_1_1: object;
    key2Scale_1: object;
    keyGlowAlpha_2_copy: object;
    key2Scale_1_2: object;
    key2Position_1_1: object;
    key2Scale_1_3: object;
    key2Position_1_1_copy: object;
    key2Scale_1_4: object;
    key2Position_1_1_copy_copy: object;
    key2Position_1_1_copy_copy_copy: object;
  };

  flowData = raw.animations[2];
}
